import {combineEpics} from 'web-app/util/redux-observable';
import * as NotificationCountsActions from 'web-app/react/notifications/notification-counts/actions';

import * as Actions from './actions';

const setBannerWarnings = action$ =>
    action$
        .ofType(NotificationCountsActions.getNotificationCountSuccess.type)
        .map(({payload}) => Actions.addWarnings.action(payload.response.warnings));

export default combineEpics(setBannerWarnings);
